export default "__VITE_ASSET__FIl7WFfz__"